import { safeSessionStorage } from "@/utils/safeStorage"

export const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /^Load failed/i, // Safari chunk load failure
  /is not a valid JavaScript MIME type/i, // Chromium: stale chunk URL falls back to index.html
  /Failed to load module script/i, // Chromium: module script failed (network/MIME)
  /Importing a module script failed/i // Safari: module script failed
]

export const CHUNK_RELOAD_SESSION_KEY = "chunkReloadAttempted"

export const isChunkLoadError = (message: string): boolean =>
  CHUNK_LOAD_ERROR_PATTERNS.some(pattern => pattern.test(message))

// Triggers a one-shot reload to recover from stale-chunk errors after deploy.
// Returns true when a reload is initiated so callers can short-circuit further handling.
export const tryReloadOnChunkError = (message: string): boolean => {
  if (!isChunkLoadError(message)) return false

  const hasReloaded = safeSessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)
  if (hasReloaded) {
    console.warn("Chunk load failed again after reload, skipping:", message)
    safeSessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY)
    return false
  }

  console.warn("Chunk load failed after deploy, reloading page:", message)
  safeSessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, "true")
  globalThis.location.reload()
  return true
}
